import { ArrowUpRight, type LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

export type WorkspaceTone = "violet" | "mint" | "peach" | "blue";

export function WorkspaceHeader({
  title,
  eyebrow,
  description,
  icon: Icon,
  tone = "violet",
}: {
  title: string;
  eyebrow: string;
  description: string;
  icon: LucideIcon;
  tone?: WorkspaceTone;
}) {
  return (
    <section className={`fe-workspace-header fe-tone-${tone}`}>
      <div className="fe-workspace-header-inner">
        <div>
          <div className="fe-eyebrow">
            <span className="fe-status-dot" />
            {eyebrow}
          </div>
          <h1>
            {title}
            <span className="fe-heading-dot">.</span>
          </h1>
          <p>{description}</p>
        </div>
        <div className="fe-workspace-symbol" aria-hidden="true">
          <Icon strokeWidth={1.5} />
        </div>
      </div>
      <div className="fe-workspace-header-bottom">
        <Link to="/">
          Foreducator <span>/</span> <strong>{title}</strong>
        </Link>
        <Link to="/guide">
          이용 가이드 <ArrowUpRight size={15} />
        </Link>
      </div>
    </section>
  );
}
